var map = {
	"./ai-icon.svg": "./cheops/src/containers/InformationLinkCard/icons/ai-icon.svg",
	"./aiDay-icon.svg": "./cheops/src/containers/InformationLinkCard/icons/aiDay-icon.svg",
	"./bday-icon.svg": "./cheops/src/containers/InformationLinkCard/icons/bday-icon.svg",
	"./shedule-link-professor.png": "./cheops/src/containers/InformationLinkCard/icons/shedule-link-professor.png",
	"./vos-icon.svg": "./cheops/src/containers/InformationLinkCard/icons/vos-icon.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./cheops/src/containers/InformationLinkCard/icons sync recursive ^\\.\\/.*$";